<template>
  <div class="running-recipes">
    <div
      v-if="!!runningRecipes?.length && currentRecipe?.queueType === QueueTypes.COMMON"
      class="running-recipes-header"
    >
      <p>{{ $t('craftingRunningRecipes') }}:</p>
      <el-checkbox id="agree-cb" v-model="onlyMineRecipes" type="checkbox" class="checkbox" size="large">
        {{ $t('craftingShowOnlyMine') }}
      </el-checkbox>
    </div>
    <div v-if="!!runningRecipes?.length || runningRecipe" class="running-recipes-list">
      <CraftingAvailableTokensForClaim
        v-if="runningRecipe && !(onlyMineRecipes && runningRecipe.userAddress !== address)"
        :token-metadata="props.tokenMetadata"
        :running-recipe="runningRecipe"
        :recipe-id="props.recipeId"
        :is-claim-button-loading="props.isClaimButtonLoading"
        @claim-load-state-changed="(isLoading) => emit('claimLoadStateChanged', isLoading)"
      />
      <!-- <CraftingRunningRecipeRow
        v-for="pendingRecipe in recipesPending"
        :key="pendingRecipe.transactionHash"
        :transaction-hash="pendingRecipe.transactionHash"
        :token-metadata="props.tokenMetadata"
      /> -->
      <CraftingRunningRecipeRow
        v-for="recipeItem in filteredRecipes?.sort(
          (rec, recNenx) => new Date(rec.craftStartTime).getTime() - new Date(recNenx.craftStartTime).getTime()
        )"
        :key="recipeItem.craftStartTime"
        :running-recipe="recipeItem"
        :recipe="currentRecipe"
        :token-metadata="props.tokenMetadata"
      />
    </div>
    <div v-else>
      <h2 class="running-recipes-empty">{{ $t('craftingEmptyRunningRecipes') }}</h2>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useWeb3ModalAccount } from '@web3modal/ethers/vue';
import type { RecipeProps } from '~/types/crafting';
import { QueueTypes, type TTokensConfigItem } from '~/utils/constants';
import type { RunningRecipeProps } from '~/types/crafting';

const { address } = useWeb3ModalAccount();
const onlyMineRecipes = ref(false);

const props = defineProps<{
  recipeId: string;
  tokenMetadata: TTokensConfigItem;
  isClaimButtonLoading: boolean;
}>();

const emit = defineEmits<{
  claimLoadStateChanged: [isLoading: boolean];
}>();

const currentRecipe = inject<Ref<RecipeProps>>('currentRecipe');
const getRecipeTime = inject<(time: string) => number>('getRecipeTime', () => 0);
const runningRecipe = inject<Readonly<Ref<RunningRecipeProps>>>('runningRecipe');
const reactiveNow = inject<Ref<number>>('reactiveNow', ref(Date.now()));

const { data: runningRecipes } = useNuxtData<RunningRecipeProps[]>(`recipes/in-queue`);

// const { data: recipesPending } = useFetch<RecipesPendingProps[]>(() => `/crafting/recipes/pending`, {
//   baseURL: apiUrl,
//   query: {
//     recipeId: props.recipeId,
//     buildingHash: () => building?.value.buildingHash || ZeroHash,
//     userAddress: address
//   }
// });

const currentUserRecipes = computed(() => {
  return runningRecipes.value?.filter((recipe) => recipe.userAddress === address.value);
});

const filteredRecipes = computed(() => {
  const recipes = onlyMineRecipes.value ? currentUserRecipes.value : runningRecipes.value;

  return recipes?.filter((recipe) => reactiveNow.value < getRecipeTime(recipe.craftStartTime));
});
</script>

<style lang="scss">
.running-recipes {
  background: #0d242f;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  @media screen and (max-width: 900px) {
    border: none;
    margin: 0;
    background: none;
    border-radius: 0;
  }

  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px 12px;
    position: sticky;
    top: 0;
    background: #0d242f;
    z-index: 5;

    @media screen and (max-width: 479px) {
      padding-right: 10px;
      padding-left: 10px;
    }

    p {
      margin: 0;
      color: #fff;
      font-family: Grenze;
      font-weight: 500;
      font-size: 18px;
    }
  }

  &-empty {
    font-size: 21px;
    text-align: center;
    color: #fff;
  }

  &-list {
    max-height: 210px;
    @media screen and (max-width: 900px) {
      max-height: unset;
    }
  }
}
</style>
